/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Selected_Jobs_LinkedInputs */

const en_selected_jobs_linked = /** @type {(inputs: Selected_Jobs_LinkedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected job(s) will be linked to your registration.`)
};

const de_selected_jobs_linked = /** @type {(inputs: Selected_Jobs_LinkedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ausgewählte Stelle(n) werden mit deiner Registrierung verknüpft.`)
};

/**
* | output |
* | --- |
* | "{count} selected job(s) will be linked to your registration." |
*
* @param {Selected_Jobs_LinkedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const selected_jobs_linked = /** @type {((inputs: Selected_Jobs_LinkedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selected_Jobs_LinkedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_selected_jobs_linked(inputs)
	return en_selected_jobs_linked(inputs)
});